// dbext:profile=staging_mcdo2019_be
import $        from "jquery";
import Sortable from "sortablejs";

import admin_general      from "./905-admin_general.js"      ;
import admin_crud         from "./910-admin_crud.js"         ;
import admin_upload_image from "./911-admin_upload_image.js" ;

export default {

    init()
    {
        // categories overview?
        if ( $('.c-admin-services' ).length > 0 ){
            this.init_services();
        }
        // category page?
        else if ( $('.c-admin-service' ).length > 0 ){
            this.init_service();
        }
    },

    // ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  SERVICES  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_services()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // make services sortable
        new Sortable( $('.js-services--sortable')[0], {
            animation : 100,
            onUpdate  : this.on__sort_services__update(),
        } );
    },

    on__sort_services__update()
    {
        return async( e ) => {

            // dom elements
            let de_sorted_item = $(e.item);

            // service ids
            let service_ids = [];

            $('.js-services').find('li').each(( i, de_service ) => {
                de_service = $(de_service);
                service_ids.push( de_service.data( 'service_id' ) );
            });

            var weight = 10;
            for ( let id of service_ids ){

                let response = await
                admin_crud.POST( admin_crud.posturl( '250_service', 'update' ), {
                    ids  : {
                            'id' : id ,
                           },
                    data:  {
                            'weight' : weight,
                           },
                } );

                weight += 10;
            }
        };
    },

    //⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩  SERVICE  ⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩⇩

    async init_service()
    {
        // add McDonald's breadcrumb
        admin_general.bread_crumb_add_mcdonalds_link();

        // event handlers
        $('.js-form'         ).on( 'submit', this.on__form__submit()         );
        $('.js-delete-button').on( 'click' , this.on__delete_button__click() );
        $('.js-tab__delete'  ).on( 'click' , this.on__delete_tab__click()    );

        // initialize the image upload
        let image_upload = new admin_upload_image();
        image_upload.init( {
            wrapper_class : '.js-image-upload',
            post_url      : '/admin/upload/service-image',
        } );

        // reset checkbox ( it gets checked again later )
        $('input[name="visible_in_restofinder_filters"]'   ).prop( 'checked', false );
        $('input[name="visible_in_restofinder_restaurant"]').prop( 'checked', false );

        // insert mode?
        if ( g_mode === 'insert' ){

            // visible in restofinder checkbox ⇒ default on
            $('input[name="visible_in_restofinder_filters"]'   ).prop( 'checked', true );
            $('input[name="visible_in_restofinder_restaurant"]').prop( 'checked', true );

            // published default on
            $('input[name="published"]').prop( 'checked', true );

            // default off
            $('select[name="default_on_off]').val( 'off' );
        }

        // update mode? ⇒ make frontend reflect g_service
        if ( g_mode === 'update' ){

            for ( let [ key, value ] of Object.entries( g_service ) ){

                // empty value? ⇒ do nothing
                if ( value === null ){
                    continue;
                }

                // image
                if ( key === 'image' && value ){
                    image_upload.set_image( value );
                    continue;
                }

                // we need strings from now on
                if ( typeof value !== 'string' ){
                    continue;
                }

                // get the DOM element
                let de = $('[name="' + key + '"]');
                if ( de.length === 0 ){
                    continue;
                }

                // input type text
                if ( de.attr('type') === 'text' ){
                    de.val( value );
                    continue;
                }

                // input type checkbox
                if ( de.attr('type') === 'checkbox' ){
                    de.prop( 'checked', ( value == 1 ) );
                    continue;
                }

                // select
                if ( de.is( 'select' ) ){
                    de.val( value );
                    continue;
                }

            }
        }

    },

    on__form__submit()
    {
        return async ( e ) => {

            e.preventDefault();

            admin_general.start_spinning();

            // delete button clicked? ⇒ handle separately
            if ( $('.js-delete-button').data( 'delete-button-clicked' ) ){
                $('.js-delete-button').removeData( 'delete-button-clicked' );
                return this.on__form_delete__submit();
            }

            { // collect form data
                var service_data = {};

                // get form data
                let form_data = $('.js-form').serializeArray();

                // form data → data structures
                for ( let { name, value } of form_data ){
                    service_data[ name ] = value;
                }

                // empty checkboxe ⇒ set explicitely
                if ( ! service_data['visible_in_restofinder_filters'] ){
                    service_data['visible_in_restofinder_filters'] = 0;
                }

                // empty checkboxe ⇒ set explicitely
                if ( ! service_data['visible_in_restofinder_restaurant'] ){
                    service_data['visible_in_restofinder_restaurant'] = 0;
                }

            }

            // validate_input
            let validated = this.validate_input( service_data );
            if ( ! validated ){

                // show errors
                $('.c-saved.c-saved--errors').show();
                $('.c-saved.c-saved--errors').fadeOut( 2000 );

                admin_general.stop_spinning();

                return;
            }

            // this will contain service-id later
            let service_id = false;

            // insert? ⇒ insert service data in database and get the service_id
            if ( g_mode === 'insert' ){

                // insert service datacfr. 910-admin-crud.js
                let response = await
                admin_crud.POST( admin_crud.posturl( '250_service', 'insert' ), {
                    data : service_data,
                } );

                service_id = response.data.id;
            }

            // update? ⇒ update service data in database
            if ( g_mode === 'update' ){

                // get service-id from g_service
                service_id = g_service.id

                let ids = {
                    'id': service_id,
                };

                let response = await
                admin_crud.POST( admin_crud.posturl( '250_service', 'update' ), {
                    ids  : {
                            'id': service_id,
                           },
                    data : service_data,
                } );

            }

            { // handle redirect/reload

                if ( g_mode === 'insert' ){

                    let target_url = '/admin/service/' + service_id;

                    // redirect to the edit page of the new service
                    window.location.replace( target_url );
                }
                else if ( g_mode === 'update' ){

                    // show service saved
                    $('.c-saved.c-saved--ok').show();
                    $('.c-saved.c-saved--ok').fadeOut('slow');
                }
            }

            admin_general.stop_spinning();
        };
    },

    on__delete_button__click()
    {
        return ( e ) => {
            $('.js-delete-button').data( 'delete-button-clicked', true );
        };
    },

    on__delete_tab__click()
    {
        return ( e ) => {
            e.preventDefault();

            // fake that somebody clicked on the delete button on the bottom of the page
            $('.js-delete-button').click();
        };
    },

    async on__form_delete__submit()
    {

        // are your sure?
        if ( ! confirm( 'Are you sure?' ) ){
            admin_general.stop_spinning();
            return; // user is not sure...
        }

        // delete service restaurant (260_service_restaurant) records where this service is used
        await this.delete_service_restaurant_records_of_service( g_service.id );

        // delete service record
        let response = await
        admin_crud.POST( admin_crud.posturl( '250_service', 'delete' ), {
            ids : {
                id : g_service.id,
            },
        } );

        // redirect to services overview
        window.location.replace( '/admin/services' );

        return;
    },

    validate_input( service_data )
    {
        $('.is-error').removeClass( 'is-error' );

        let validated = true;

        for ( let key of [ 'name_en', 'name_nl', 'name_fr',  ] ){
            if ( ! service_data[key] ){
                $('[name="'+key+'"]').addClass( 'is-error' );
                validated = false;
            }
        }

        return validated;
    },

    async delete_service_restaurant_records_of_service( service_id )
    {
        // load records to delete
        let records = await ( async () => {
            let response = await
            admin_crud.GET( admin_crud.posturl( '260_service_restaurant', 'select_where' ), {
                'where' : {
                    'service_id': service_id,
                }
            } );
            return response.data;
        })();

        // delete records
        for ( let r of records ){
            let response = await
            admin_crud.POST( admin_crud.posturl( '260_service_restaurant', 'delete' ), {
                ids : {
                    service_id    : r.service_id   ,
                    restaurant_id : r.restaurant_id,
                },
            } );
        }
    },

}

